'use strict';

require('./app.js');
